import { parseISO } from 'date-fns';
import type { NodeLoginDataObject, NodeUserDataObject } from '../service';
import { getUserName } from './get-user-name';
import type { NodeMembership } from './memberships';

export type NodeLogin = {
  token: string;
} & NodeUser;

export type NodeUser = {
  _id: MongoId;
  createdAt?: Date;
  email: string;
  firstName?: string;
  fullName: string;
  lastName?: string;
  memberships?: NodeMembership[];
  middleName?: string;
  roles: NodeUserRoles;
  timezone?: string;
  updatedAt?: Date;
};

type MongoId = string;

type NodeUserRoles = {
  admin?: boolean;
  bigheartStaff?: boolean;
  personnel?: boolean;
};

export const createNodeUser = (data: NodeUserDataObject): NodeUser => ({
  _id: data._id,
  createdAt: data.createdAt ? parseISO(data.createdAt) : undefined,
  email: data.email,
  firstName: data.firstName,
  fullName: getUserName({ firstName: data.firstName, lastName: data.lastName }),
  lastName: data.lastName,
  memberships: data.membership,
  middleName: data.middleName,
  roles: data.roles,
  timezone: data.timezone,
  updatedAt: data.updatedAt ? parseISO(data.updatedAt) : undefined,
});

export const createNodeLogin = (data: NodeLoginDataObject): NodeLogin => {
  const user = createNodeUser(data);

  return {
    ...user,
    token: data.token,
  };
};
